export default __webpack_public_path__ + "static/media/icon-alert-warning.01c88164.svg";